import { IdentityType } from "../../types/limited-company-creation/identityType";

export const identityInitialState: IdentityType = {
    civility: "Monsieur",
    lastName: "",
    firstName: ""
}